import { render, staticRenderFns } from "./futureCommissionDetail.vue?vue&type=template&id=609b5d2c&scoped=true"
import script from "./futureCommissionDetail.vue?vue&type=script&lang=js"
export * from "./futureCommissionDetail.vue?vue&type=script&lang=js"
import style0 from "./futureCommissionDetail.vue?vue&type=style&index=0&id=609b5d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b5d2c",
  null
  
)

export default component.exports